import { isValidUkDate } from '@/shared/utils/validation';

const shiftUtc = (date: Date | string, from: boolean) => {
  if (typeof date === 'string') {
    date = new Date(Date.parse(date));
  }

  date = new Date(date.getTime());

  date.setMinutes(date.getMinutes() + date.getTimezoneOffset() * (from ? 1 : -1));

  return date;
};

export const shiftFromUtc = (date: Date | string) => shiftUtc(date, true);

export const shiftToUtc = (date: Date | string) => shiftUtc(date, false);

export const parseIsoDateTime = (value?: string | null) => {
  if (!value) return;

  // bare numbers are OADate
  if (/^\d+(\.\d+)?$/.test(value.trim())) return;

  const timestamp = Date.parse(value);
  if (isNaN(timestamp)) return;

  return new Date(timestamp);
};

export const parseOADate = (value?: string | null) => {
  if (!value) return;

  const trimmed = value.trim();

  // parseFloat is not enough
  if (!/^\d+(\.\d+)?$/.test(trimmed)) return;

  const serial = parseFloat(trimmed);

  if (serial < 1 || serial > 100000) return;

  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  const epoch = new Date(1899, 11, 30);

  return new Date(epoch.getTime() + serial * MS_PER_DAY);
};

export function parseIsoDate(value?: string | null) {
  if (!value) return;

  return parseIsoDateTime(value.substring(0, 10));
}

export const parseUkDate = (value?: string | null) => {
  if (value && isValidUkDate(value)) {
    const [day, month, year] = value.split('/');
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  }
};

export const formatIsoDate = (date: Date) => date.toISOString().substring(0, 10);

export const formatIsoDateTime = (value: Date | string): string => {
  const date = typeof value === 'string' ? new Date(value) : value;
  if (isNaN(date.getTime())) return typeof value === 'string' ? value : '';
  return `${formatIsoDate(date)}T00:00:00Z`;
};

export const datesEqual = (date1: Date, date2: Date) => date1.getTime() === date2.getTime();

export const isDate = (obj: object): obj is Date => typeof obj === 'object' && 'toISOString' in obj;
